import {
  get
} from './utils'
import auth from './auth'

export function  handleException(e, noback, callback, returnFlag = true) {
  if (!e) return;
  let code = get(e, 'data.res.hd.code');
  let desc = typeof e === "string" ? e : get(e, 'message') || get(e, 'data.res.hd.desc') || '抱歉，我们遇到一点问题，请您稍后再试。';

  let _this = this;
  return _this.$popup({
    title: '管家提示',
    content: desc,
    confirm() {
      if (code === -401 || code === -402) {
        return auth.login({
          method: 'replace',
          callback
        });
      }
      // if (noback) return;
      if (!noback && callback) {
        callback();
      } else {
        return;
      }


      if (!returnFlag) return

      _this.$router.go(-1);
    },
    cancel() {
      if (code === -401 || code === -402) {
        _this.$router.go(-1);
      }
    },
    ignore() {
      if (code === -401 || code === -402) {
        _this.$router.go(-1);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/request/helpers.js